
import { UIViewEnum } from "../enums/UIViewEnum";
import { IRoute, routes } from "../../routes/routes";
import _ from "lodash";
import Enumerable from "linq";

export function getNavigationRoutes(availableViews: UIViewEnum[], isPhone: boolean): IRoute[] {

    // const navigationRoutes = availableViews.reduce((result: IRoute[], currentValue) => { 
    //     return result.concat(routes.filter(o => o.viewID === currentValue))
    // }, []);

    // This will maintain the ordering of the routes as listed
    const navigationRoutes = Enumerable
        .from(routes)
        .join(
            availableViews,
            o => o?.viewID,
            i => i,
            (o, _i) => o
        ).toArray();

    // do not show both gauge sheet and manual entry
    const hasGaugeSheet = navigationRoutes.find(o => o.viewID === UIViewEnum.Device_GaugeSheet) ? true : false;

    const copy = _.cloneDeep(navigationRoutes);

    const manualEntry = copy.find(o => o.viewID === UIViewEnum.Device_ManualEntry);

    if (manualEntry && !isPhone)
    {
        const gaugeSheet = routes.find(o => o.viewID === UIViewEnum.Device_GaugeSheet);

        if (gaugeSheet) {

            //manualEntry.path = gaugeSheet.path;
            //manualEntry.fullPath = gaugeSheet.fullPath;
            manualEntry.component = gaugeSheet.component;
        }
    }
    if (isPhone && !manualEntry && hasGaugeSheet) {
        copy.push(routes.find(o => o.viewID === UIViewEnum.Device_ManualEntry) as IRoute);

    }

    //copy.push(routes.find(o => o.viewID === UIViewEnum.Device_DynacardDashboard) as IRoute);

    return isPhone ? 
        copy.filter(o => o.allowMobile) : 
        hasGaugeSheet ? 
            copy.filter(o => o.viewID !== UIViewEnum.Device_ManualEntry) : 
            copy;

}

// export function getNavigationRoutes(availableViews: UIViewEnum[], isPhone: boolean): IRoute[] {

//     const navigationRoutes = availableViews.reduce((result: IRoute[], currentValue) => { 
//         return result.concat(routes.filter(o => o.viewID === currentValue))
//     }, []);

//     // do not show both gauge sheet and manual entry
//     const hasGaugeSheet = navigationRoutes.find(o => o.viewID === UIViewEnum.Device_GaugeSheet) ? true : false;

//     const copy = _.cloneDeep(navigationRoutes);

//     const manualEntry = copy.find(o => o.viewID === UIViewEnum.Device_ManualEntry);

//     if (manualEntry && !isPhone)
//     {
//         const gaugeSheet = routes.find(o => o.viewID === UIViewEnum.Device_GaugeSheet);

//         if (gaugeSheet) {

//             //manualEntry.path = gaugeSheet.path;
//             //manualEntry.fullPath = gaugeSheet.fullPath;
//             manualEntry.component = gaugeSheet.component;
//         }
//     }

//     return isPhone ? 
//         copy.filter(o => o.allowMobile) : 
//         hasGaugeSheet ? 
//             copy.filter(o => o.viewID !== UIViewEnum.Device_ManualEntry) : 
//             copy;

// }





